"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _components = require("components");

var _translationNode = require("egov-ui-kit/utils/translationNode");

var _translationNode2 = _interopRequireDefault(_translationNode);

var _reactRedux = require("react-redux");

var _AssessmentInfo = require("../../../Property/components/AssessmentInfo");

var _AssessmentInfo2 = _interopRequireDefault(_AssessmentInfo);

var _PropertyAddressInfo = require("../../../Property/components/PropertyAddressInfo");

var _PropertyAddressInfo2 = _interopRequireDefault(_PropertyAddressInfo);

var _OwnerInfo = require("../../../Property/components/OwnerInfo");

var _OwnerInfo2 = _interopRequireDefault(_OwnerInfo);

var _TotalDues = require("../../../Property/components/TotalDues");

var _TotalDues2 = _interopRequireDefault(_TotalDues);

var _AssessmentHistory = require("./components/AssessmentHistory");

var _AssessmentHistory2 = _interopRequireDefault(_AssessmentHistory);

var _PaymentHistory = require("./components/PaymentHistory");

var _PaymentHistory2 = _interopRequireDefault(_PaymentHistory);

var _ApplicationHistory = require("./components/ApplicationHistory");

var _ApplicationHistory2 = _interopRequireDefault(_ApplicationHistory);

var _DocumentsInfo = require("../../../Property/components/DocumentsInfo");

var _DocumentsInfo2 = _interopRequireDefault(_DocumentsInfo);

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const PTInformation = ({
//   items,
//   label,
//   onItemClick,
//   innerDivStyle,
//   hoverColor,
//   properties,
//   style,
//   generalMDMSDataById,
//   totalBillAmountDue,
//   history,
//   documentsUploaded,
//   toggleSnackbarAndSetText
// }) => {
//   const items2 = [items[1]];
//   return (
//     <div className="form-without-button-cont-generic">
//       {label && (
//         <Label
//           label={label}
//           containerStyle={{ padding: "24px 0px 24px 0", marginLeft: "16px" }}
//           dark={true}
//           bold={true}
//           labelStyle={{ letterSpacing: 0 }}
//           fontSize={"20px"}
//         />
//       )}
//       <div >
//         <Card
//           textChildren={
//             <div id="property-review-form" className="col-sm-12 col-xs-12" style={{ alignItems: "center" }}>
//               {totalBillAmountDue > 0 && (
//                 <Card
//                   textChildren={
//                     <TotalDues history tenantId={properties.tenantId} consumerCode={properties.propertyId} totalBillAmountDue={totalBillAmountDue} />
//                   }
//                   style={{ backgroundColor: "rgb(242,242,242)", boxShadow: "none" }}
//                 />
//               )}
//               {/* className="pdf-header" */}
//               <Card textChildren={
//                 <div>

//                 <Label label={"AMRITSAR MUNICIPAL CORPORATION"} fontSize="16px" fontWeight="500"/>
//                 <Label label={"Property Tax Assessment Confirmation"} fontSize="14px" fontWeight="500"/>
//                 </div>
//               } />
//               <PropertyAddressInfo properties={properties} generalMDMSDataById={generalMDMSDataById}></PropertyAddressInfo>
//               <AssessmentInfo properties={properties} generalMDMSDataById={generalMDMSDataById}></AssessmentInfo>
//               <OwnerInfo
//               toggleSnackbarAndSetText={toggleSnackbarAndSetText}
//                 properties={properties}
//                 generalMDMSDataById={generalMDMSDataById}
//                 totalBillAmountDue={totalBillAmountDue}
//                 ownershipTransfer={true}
//                 viewHistory={true}
//               ></OwnerInfo>
//               <DocumentsInfo documentsUploaded={documentsUploaded}></DocumentsInfo>
//               <div id="property-assess-form">
//                 <AssessmentHistory></AssessmentHistory>
//                 <PaymentHistory></PaymentHistory>
//                 <ApplicationHistory></ApplicationHistory>
//               </div>
//             </div>
//           }
//         />
//       </div>
//     </div>
//   );
// };


var logoStyle = {
  height: "61px",
  width: "60px"
};

var PTInformation = function (_React$Component) {
  (0, _inherits3.default)(PTInformation, _React$Component);

  function PTInformation() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PTInformation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PTInformation.__proto__ || Object.getPrototypeOf(PTInformation)).call.apply(_ref, [this].concat(args))), _this), _this.getLogoUrl = function (tenantId) {
      var cities = _this.props.cities;

      var filteredCity = cities && cities.length > 0 && cities.filter(function (item) {
        return item.code === tenantId;
      });
      return filteredCity ? (0, _get2.default)(filteredCity[0], "logoId") : "";
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PTInformation, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          label = _props.label,
          properties = _props.properties,
          generalMDMSDataById = _props.generalMDMSDataById,
          totalBillAmountDue = _props.totalBillAmountDue,
          documentsUploaded = _props.documentsUploaded,
          toggleSnackbarAndSetText = _props.toggleSnackbarAndSetText,
          cities = _props.cities;

      var logoUrl = "";
      var corpCity = "";
      var ulbGrade = "";
      if ((0, _get2.default)(properties, "tenantId")) {
        logoUrl = (0, _get2.default)(properties, "tenantId") ? this.getLogoUrl((0, _get2.default)(properties, "tenantId")) : "";
        corpCity = "TENANT_TENANTS_" + (0, _get2.default)(properties, "tenantId").toUpperCase().replace(/[.:-\s\/]/g, "_");
        var selectedCityObject = cities && cities.length > 0 && cities.filter(function (item) {
          return item.code === (0, _get2.default)(properties, "tenantId");
        });
        ulbGrade = selectedCityObject ? "ULBGRADE_" + (0, _get2.default)(selectedCityObject[0], "city.ulbGrade") : "MUNICIPAL CORPORATION";
      }

      return _react2.default.createElement(
        "div",
        { className: "form-without-button-cont-generic" },
        label && _react2.default.createElement(_translationNode2.default, {
          label: label,
          containerStyle: { padding: "24px 0px 24px 0", marginLeft: "16px" },
          dark: true,
          bold: true,
          labelStyle: { letterSpacing: 0 },
          fontSize: "20px"
        }),
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(_components.Card, {
            textChildren: _react2.default.createElement(
              "div",
              { id: "property-review-form", className: "col-sm-12 col-xs-12", style: { alignItems: "center" } },
              totalBillAmountDue > 0 && _react2.default.createElement(_components.Card, {
                textChildren: _react2.default.createElement(_TotalDues2.default, {
                  history: true,
                  tenantId: properties.tenantId,
                  consumerCode: properties.propertyId,
                  totalBillAmountDue: totalBillAmountDue
                }),
                style: { backgroundColor: "rgb(242,242,242)", boxShadow: "none" }
              }),
              _react2.default.createElement(
                "div",
                { className: "pdf-header", id: "pdf-header" },
                _react2.default.createElement(_components.Card, {
                  style: { display: "flex", backgroundColor: "rgb(242, 242, 242)", minHeight: "120px", alignItems: "center", paddingLeft: "10px" },
                  textChildren: _react2.default.createElement(
                    "div",
                    { style: { display: "flex" } },
                    _react2.default.createElement(
                      "div",
                      { style: { marginLeft: 30 } },
                      _react2.default.createElement(
                        "div",
                        { style: { display: "flex", marginBottom: 5 } },
                        _react2.default.createElement(_translationNode2.default, { label: corpCity, fontSize: "20px", fontWeight: "500", color: "rgba(0, 0, 0, 0.87)", containerStyle: { marginRight: 10, textTransform: "uppercase" } }),
                        _react2.default.createElement(_translationNode2.default, { label: ulbGrade, fontSize: "20px", fontWeight: "500", color: "rgba(0, 0, 0, 0.87)" })
                      ),
                      _react2.default.createElement(_translationNode2.default, { label: "PT_PDF_SUBHEADER", fontSize: "16px", fontWeight: "500" })
                    )
                  )
                }),
                _react2.default.createElement(
                  "div",
                  { style: { display: "flex", justifyContent: "space-between" } },
                  _react2.default.createElement(
                    "div",
                    { style: { display: "flex" } },
                    _react2.default.createElement(_translationNode2.default, { label: "PT_PROPERTY_ID", color: "rgba(0, 0, 0, 0.87)", fontSize: "20px", containerStyle: { marginRight: 10 } }),
                    _react2.default.createElement(_translationNode2.default, { label: ": " + (0, _get2.default)(properties, "propertyId"), fontSize: "20px" })
                  )
                )
              ),
              _react2.default.createElement(_PropertyAddressInfo2.default, { properties: properties, generalMDMSDataById: generalMDMSDataById }),
              _react2.default.createElement(_AssessmentInfo2.default, { properties: properties, generalMDMSDataById: generalMDMSDataById }),
              _react2.default.createElement(_OwnerInfo2.default, {
                toggleSnackbarAndSetText: toggleSnackbarAndSetText,
                properties: properties,
                generalMDMSDataById: generalMDMSDataById,
                totalBillAmountDue: totalBillAmountDue,
                ownershipTransfer: true,
                viewHistory: true
              }),
              _react2.default.createElement(_DocumentsInfo2.default, { documentsUploaded: documentsUploaded }),
              _react2.default.createElement(
                "div",
                { id: "property-assess-form" },
                _react2.default.createElement(_AssessmentHistory2.default, null),
                _react2.default.createElement(_PaymentHistory2.default, null),
                _react2.default.createElement(_ApplicationHistory2.default, null)
              )
            )
          })
        )
      );
    }
  }]);
  return PTInformation;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  var _ref2 = state.common || [],
      cities = _ref2.cities;

  return { cities: cities };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(PTInformation);


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/common/propertyTax/AssessmentList/components/PTInformation/index.js
// module id = 3582
// module chunks = 1143